export const WorkspaceAreasStep = () => {
  return <div>Areas</div>
}
